import * as React from "react"
const  NewemployIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22}
    height={22}
    style={{
      enableBackground: "new 0 0 512 512",
    }}
    viewBox="0 0 64 64"
    {...props}
  >
    <g fill="#fff">
      <path
        d="M30.46 32.15a14.075 14.075 0 1 0 0-28.15c-18.655.771-18.67 27.38 0 28.15zm16.09 3.73a12.06 12.06 0 1 0 12.06 12.06 12.092 12.092 0 0 0-12.06-12.06zm5 13.06h-4v4a1 1 0 0 1-2 0v-4h-4a1 1 0 0 1 0-2h4v-4a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2z"
        data-original="#000000"
      />
      <path
        d="M37.97 36.81q.435-.33.9-.63c-4.492-1.79-9.553-2.53-14.2-.88l-11.4 3.8a11.52 11.52 0 0 0-7.88 10.94v5.45A4.016 4.016 0 0 0 9.4 59.5h6.08v-4.63a1 1 0 0 1 2 0v4.63h21.09c-7.774-5.078-8.097-17.202-.6-22.69z"
        data-original="#000000"
      />
    </g>
  </svg>
)
export default NewemployIcon
